import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyBUSohqnY31EXRu3IpdT5zn5srFF6sPv3g",
    authDomain: "jornal-da-cidade-online-4b2ca.firebaseapp.com",
    projectId: "jornal-da-cidade-online-4b2ca",
    storageBucket: "jornal-da-cidade-online-4b2ca.appspot.com",
    messagingSenderId: "60406285808",
    appId: "1:60406285808:web:45eaf65947e1d64c61c935",
    measurementId: "G-VBHT0H058Y",
  };

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

function inscreverEmTopico(clientToken) {

  const formData = new FormData();
  formData.append("clientToken", clientToken);

  fetch("//fcm.jornaldacidadeonline.com.br/subscribe", {
    method: "POST",
    headers: {
    },
    body: formData,
  })
  .then(response => response.json())
  .then(data => {
    console.log(data);
  })
  .catch(error => {
    console.error("Erro ao inscrever no tópico:", error);
  });
}

async function requestPermission() {
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    const clientToken = await getToken(messaging, { vapidKey: "BPk0msg3Fmta_R_dxMO4k98hKhJeCfEnlMdENZREy8Cgo28Fz5A1c_2nB52j8IAMxP1WmlqYJXwDPfjodTo6SQ8"});
    inscreverEmTopico(clientToken)
    
  } else {
    console.error("Permissão negada para notificações.");
  }
}

requestPermission();

onMessage(messaging, (payload) => {
  console.log("Mensagem recebida:", payload);
});